import { render } from "./Duotone.vue?vue&type=template&id=ee27807c"
import script from "./Duotone.vue?vue&type=script&lang=ts"
export * from "./Duotone.vue?vue&type=script&lang=ts"
script.render = render

export default script